import { Component, OnInit } from '@angular/core';
import { FirestoreService } from '../../services/firestore.service';
import { UsuarioModel } from '../../models/usuario.model';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})


export class DashboardComponent implements OnInit {

  public participantes:UsuarioModel[] = [];

  constructor(
    private fireStore: FirestoreService
  ) { }

  ngOnInit(): void {

    this.fireStore.getInscritos()
      .subscribe( resp => {
        this.participantes = resp;
      });
  }

}
